<template>
    <div class="ShareSet">
        <div class="help_share_set_box spackage bgc box-shadow">
            <div class="title_box padding-20">
                <p class="title_text">助力分享链接设置</p>
            </div>
            <div class="set_content_box padding-20">
                <div class="set_item_box flex_center">
                    <span>分享图片</span>
                    <div class="set_img_box">
                        <img :src="shareSetParams.assshareatturl === '' ? require('@/common/images/communityPurchases/default.png') : shareSetParams.assshareatturl" alt="">
                        <div>
                            <uploadFile :uploadType="uploadType" @setFile="setFile1" :fileRule="fileRule" ref="uploadFile1"></uploadFile>
                            <p>建议尺寸80*80px的JPG、PNG格式， 图片小于2M。</p>
                        </div>
                    </div>
                </div>
                <div class="set_item_box flex_center">
                    <span>分享标题</span>
                    <div style="width: 400px;">
                        <el-input v-model="shareSetParams.asssharesubject" placeholder="输入分享标题，不超过30个字"></el-input>
                    </div>
                </div>
                <div class="set_item_box flex_center">
                    <span>分享内容</span>
                    <div style="width: 400px;">
                        <el-input v-model="shareSetParams.asssharecontent" placeholder="输入分享内容，不超过80个字"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="activity_share_set_box spackage bgc box-shadow">
            <div class="title_box padding-20">
                <p class="title_text">活动分享链接设置</p>
            </div>
            <div class="set_content_box padding-20">
                <div class="set_item_box flex_center">
                    <span>分享图片</span>
                    <div class="set_img_box">
                        <img :src="shareSetParams.eventshareatturl === '' ? require('@/common/images/communityPurchases/default.png') : shareSetParams.eventshareatturl" alt="">
                        <div>
                            <uploadFile :uploadType="uploadType" @setFile="setFile2" :fileRule="fileRule" ref="uploadFile2"></uploadFile>
                            <p>建议尺寸80*80px的JPG、PNG格式， 图片小于2M。</p>
                        </div>
                    </div>
                </div>
                <div class="set_item_box flex_center">
                    <span>分享标题</span>
                    <div style="width: 400px;">
                        <el-input v-model="shareSetParams.eventsharesubject" placeholder="输入分享标题，不超过30个字"></el-input>
                    </div>
                </div>
                <div class="set_item_box flex_center">
                    <span>分享内容</span>
                    <div style="width: 400px;">
                        <el-input v-model="shareSetParams.eventsharecontent" placeholder="输入分享内容，不超过80个字"></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <el-button @click="cancel">取消</el-button>
                    <el-button @click="submitShareSet" type="primary">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UploadFile from 'base/upload/uploadFile'
import {mapActions} from 'vuex'
import {getAssEventShareSettingInfo, updateAssEventShareSettingInfo} from 'api/taskToolsApi'
import {formatFileInfo} from 'common/js/tools'
export default {
    name: 'ShareSet',
    data() {
        return {
            assImgInfo: {},
            eventImgInfo: {},
            shareSetParams: {
                assshareattid: '',
                assshareatturl: '',
                asssharecontent: '',
                asssharesubject: '',
                eventinnerid: '',
                eventshareattid: '',
                eventshareatturl: '',
                eventsharecontent: '',
                eventsharesubject: ''
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: 'image/png,image/jpeg,image/gif',
                size: 10,
                width: 350,
                height: 350
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            }
        }
    },
    mounted() {
        this.getShareInfo()
    },
    methods: {
        getShareInfo() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getAssEventShareSettingInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.shareSetParams = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 保存分享设置
        submitShareSet() {
            this.setLoading(true)
            var params = {
                assshareurl: formatFileInfo(this.assImgInfo),
                eventshareurl: formatFileInfo(this.eventImgInfo)
            }
            updateAssEventShareSettingInfo({
                data: Object.assign({}, params, this.shareSetParams),
                success: data => {
                    this.setLoading(false)
                    window.history.back()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        cancel() {
            window.history.back()
        },
        // 上传图片
        setFile1(file) {
            // console.log('助力图片设置：', file)
            this.shareSetParams.assshareatturl = file.furl
            this.assImgInfo = file
            this.$refs.uploadFile1.initUploadParam()
        },
        // 上传图片
        setFile2(file) {
            // console.log('活动图片设置：', file)
            this.shareSetParams.eventshareatturl = file.furl
            this.eventImgInfo = file
            this.$refs.uploadFile1.initUploadParam()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UploadFile
    }
}
</script>

<style lang="scss" type="text/scss">
.ShareSet {
    color: #303133;
    .flex_center {
        display: flex;
        align-items: center;
    }
    .help_share_set_box, .activity_share_set_box {
        margin-bottom: 24px;
        .title_box {
            border-bottom: 1px solid #DCDFE6;
            .title_text {
                border-left: 2px solid #409EFF;
                padding-left: 10px;
                font-weight: bold;
                line-height: 16px;
                font-size:16px;
            }
        }
        .set_content_box {
            .set_item_box {
                margin-bottom: 20px;
                &>span {
                    color: #36383A;
                    width: 84px;
                }
                .set_img_box {
                    display: flex;
                    &>img{
                        width: 80px;
                        height: 80px;
                        border-radius: 4px;
                        margin-right: 24px;
                    }
                    &>div{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .el-button{
                            min-width: 96px;
                            height: 32px;
                            padding: 0;
                            background: #fff;
                            border: 1px solid #C0C4CC;
                            color: #606266;
                        }
                        .el-button:hover{
                            border: 1px solid #409EFF;
                            color: #409EFF;
                        }
                        &>p{
                            margin-top: 12px;
                            color: #909399;
                        }
                    }
                }
            }
            .set_item_box:nth-last-of-type(1) {
                margin-bottom: 0;
            }
            .btn_box {
                margin-top: 40px;
                padding-left: 84px;
            }
        }
    }
}
</style>